import React, { useContext, useState } from "react";
import { VendorContext } from "../../../../../context/vendor/VendorContext";
import { Button, Container, Column, ColumnButtons, Tittle } from "../style";
import { useTranslation } from "react-i18next";
import { OneColumn } from "./style";

const Step6 = () => {
  const { t } = useTranslation();
  const { steps } = useContext(VendorContext);

  return (
    <>
      <Tittle>{t(steps[5])}</Tittle>
      <br />
      <br />
      <Container>
        <OneColumn>
          <h5>{t("enrollmentComplete")}</h5>
        </OneColumn>
      </Container>
    </>
  );
};

export default Step6;
